<template>
  <li  :class="itemClass" @click="handleClick" :aria-selected="focused" >
    <div
      role="option"
      :aria-selected="focused"
     class="k-item"
    >
     {{ dataItem.naziv}}
    </div>
    <div class="k-link sifrantACItemSkupina"> {{ dataItem.skupinaproizvoda}}</div>
    <div class="k-link sifrantACItemVrsta"> {{ dataItem.vrstaproizvoda}}</div>
    
  </li>
</template>
<script>
export default {
  props: {
    id: String,
    index: Number,
    dataItem: [Object, String, Number],
    textField: String,
    focused: Boolean,
    selected: Boolean
  },
  computed: {
    itemClass() {
      return {
        "k-item": true,
        "sifrantACItem":true,
        "sifrantACItem-focused": this.$props.focused
        
      };
    }
  },
  methods: {
    handleClick: function(e) {
      console.log(e);
      this.$emit("click", e,this.dataItem);

    }
  }
};
</script>